import { defineStore } from 'pinia';
import { ref } from 'vue';
import { type SiteResponse } from '../api/listSites';
import { useSiteStore } from './siteStore';

interface SelectedSite {
  siteId: number;
  basePath: string;
}

export const useSelectedSiteStore = defineStore('selectedSite', () => {
  const siteId = ref<number>();
  const siteName = ref('');
  const localStorageKey = 'site';
  const siteStore = useSiteStore();

  async function restore() {
    const basePath = document.querySelector('base')?.href || '/';

    const siteIdValue = siteId.value;
    if (siteIdValue !== undefined) return;
    await siteStore.initialize();

    const selectedSiteText = localStorage.getItem(localStorageKey);

    let site: SiteResponse | undefined;

    if (selectedSiteText) {
      const selectedSite: SelectedSite = JSON.parse(selectedSiteText);
      if (selectedSite && selectedSite.basePath === basePath) {
        site = siteStore.getById(selectedSite.siteId);
      } else if (selectedSiteText.length > 0) {
        const id = parseInt(selectedSiteText);
        site = siteStore.getById(id);
      }
    }

    if (!site) {
      site = siteStore.sites[0];
    }

    fill(site);
  }

  async function select(id: number) {
    await siteStore.initialize();
    const site = siteStore.getById(id);
    fill(site);
    const basePath = document.querySelector('base')?.href || '/';
    const selectedSite: SelectedSite = {
      siteId: id,
      basePath: basePath,
    };
    localStorage.setItem(localStorageKey, JSON.stringify(selectedSite));
  }

  function fill(site: SiteResponse | undefined) {
    siteId.value = site?.id;
    siteName.value = site?.name ?? '';
  }

  return {
    siteId,
    siteName,
    restore,
    select,
  };
});
